import { isArray } from './types'
import { forEach } from 'lodash-unified'

export const unique = <T>(arr: T[]) => [...new Set(arr)]

export const extractFirst = <T>(arr: T | T[]): T => {
  return isArray(arr) ? arr[0] : arr
}

type Many<T> = T | ReadonlyArray<T>
// TODO: rename to `ensureArray`
/** like `_.castArray`, except falsy value returns empty array. */
export const castArray = <T>(arr: Many<T>): T[] => {
  if (!arr && (arr as any) !== 0) return []
  return isArray(arr) ? arr : [arr as T]
}

// TODO: remove import alias
// avoid naming conflicts
export { castArray as ensureArray } from 'lodash-unified'


/** 深度优先遍历 children */
import { cloneDeep } from 'lodash-unified';

/**
 * 深度遍历树结构，执行回调，并返回处理后的新树
 * @param arr 原始树数组
 * @param cb 回调函数，用于修改节点
 * @returns 处理后的新树（深拷贝，不污染原数据）
 */
export const mapTree = <T = any>(
  arr: T[],
  cb: (item: T) => T | void
): T[] => {
  // 深拷贝，避免修改原数组
  const result = cloneDeep(arr);

  forEach(result, (item) => {
    // 执行回调，支持修改节点
    const processed = cb(item);
    // 如果回调有返回值，用返回值覆盖节点
    if (processed !== undefined) {
      Object.assign(item, processed);
    }

    // 递归 children
    if ((item as any).children?.length) {
      (item as any).children = mapTree((item as any).children, cb);
    }
  });

  return result;
};